// Libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Container, Form } from 'react-bootstrap';
import Select from 'react-select';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import TagService from 'services/TagService';
import VendorService from 'services/VendorService';

// Components
import Loader from 'components/common/Loader';
import EditTagModal from 'components/admin/tags/EditTagModal';
import PageHeader from 'components/common/PageHeader';
import SideBar from 'components/common/SideBar';

//-------------------------------------------------------------------------------------------------------------------

class TagsPage extends React.Component {

    constructor(props) {
        super(props);

        this.editTagModalRef = React.createRef();

        this.requestID = 1;
        this.state = {
            isLoading: true,
            isLoadingFilters: true,
            filters: {}
        };
    }
    
    async componentDidMount() {
        GlobalStateService.setValues({ area: 'tags' });
        window.scrollTo(0, 0);
        this.load();
        this.loadFilters();
    }

    async loadFilters() {
        this.setState({ isLoadingFilters: true });
        const types = TagService.listTypes().map(t => ({
            id: t,
            name: TagService.getTypeFriendly(t)
        }));
        this.setState({
            types,
            isLoadingFilters: false
        });
    }

    updateFilter(name, value) {
        const filters = { ...this.state.filters };
        filters[name] = value;
        this.setState({
            filters
        }, () =>
            this.load()
        );
    }

    async load() {
        const { type } = this.state.filters;
        const tags = await TagService.list({ type });
        this.setState({
            tags,
            isLoading: false
        });
    }

    async editTag(tag) {
        await this.editTagModalRef.current.show({
            tagID: tag.id
        });
        this.load();
    }

    async addTag() {
        const { type } = this.state.filters;
        await this.editTagModalRef.current.show({
            type
        });
        this.load();
    }

    render() {
        return (<>
            <div className="page tags-page full-width-page">

                <PageHeader hasSideBar>
                    <h1>Tags</h1>

                    <div className="buttons">

                        <button className="btn btn-primary" onClick={e => this.addTag()}>
                            <span className="fa-solid fa-plus"></span>{' '}
                            New tag
                        </button>
                        
                    </div>

                </PageHeader>

                <main>

                    <SideBar content={this.renderSideBarContent()} className="flex" />

                    <Container fluid>
                        
                        <section>

                            {this.renderInner()}

                        </section>

                    </Container>

                </main>

            </div>

            <EditTagModal ref={this.editTagModalRef} />

        </>);
    }

    renderInner() {
        const {
            isLoading,
            tags,
            filters
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        const getClass = (c) => {
            if (c.isDeprecated) {
                return 'deprecated';
            }
            return null;
        };

        return (

            <div className="sticky-table-container scrolling">

                <table className="table table-bordered sticky-table selectable tags-table">
                    <thead>
                        <tr>
                            {!filters.type &&
                                <th className="type-col">Type</th>
                            }
                            <th className="name-col">Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tags.map(t =>
                            <tr key={t.id} onClick={e => this.editTag(t)} className={getClass(t)}>
                                {!filters.type &&
                                    <td className="type-col">{TagService.getTypeFriendly(t.type)}</td>
                                }
                                <td className="name-col">
                                    <span className="tag" style={{ backgroundColor: t.backColour, color: t.textColour }}>
                                        {t.name}
                                    </span>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

            </div>

        );
    }

    renderSideBarContent() {
        const {
            isLoadingFilters,
            filters
        } = this.state;
        const types = [{ id: '', name: '(All)' }].concat(this.state.types);

        if (isLoadingFilters) {
            return (<Loader />);
        }

        return (
            <form onSubmit={e => {
                e.preventDefault();
                this.load();
            }}>
                <Form.Group className="">
                    <Form.Label>Type</Form.Label>
                    <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        value={types.find(v => v.id == filters.type)}
                        options={types}
                        getOptionValue={v => v.id}
                        getOptionLabel={v => v.name}
                        onChange={v => this.updateFilter('type', v.id)}
                    />
                </Form.Group>
            </form>
        );
    }

}

export default withRouter(TagsPage);